import { DateInput } from '@progress/kendo-react-dateinputs';
import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useViewCalendarYear from 'src/hooks/useViewCalendarYear';
import { preventDefault } from 'src/utils';
import { getBgColor } from 'src/utils/icons';

const StartDate = (props: GridCellProps) => {
  const { isPeriodEditMode } = useViewCalendarYear();
  const { dataItem, field = '' } = props;
  const value = dataItem[field];
  const formatValue = value ? format(value, 'MM/dd/yyyy') : '';
  const valid = useMemo(
    () => !dataItem?.errors?.startDate?.length,
    [dataItem.errors.startDate?.length]
  );

  return (
    <GridCellBase
      {...props}
      className={`${getBgColor(
        dataItem.errors.startDate,
        dataItem.warnings.startDate
      )} !text-center`}
      title={formatValue}
    >
      {isPeriodEditMode ? (
        <span onDragStart={preventDefault} onDragOver={preventDefault}>
          <DateInput disabled={true} value={value} valid={valid} size="small" />
        </span>
      ) : (
        formatValue
      )}
    </GridCellBase>
  );
};

export default StartDate;
